import React, { useState, useEffect, useCallback } from "react";
import { useSocket } from "../providers/Socket";
import { useNavigate } from "react-router-dom";
import logo from "../logo.jpg"; // ⬅️ your logo

const Homepage = () => {
  const { socket, setMyEmail } = useSocket();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [roomId, setRoomId] = useState("");

  const handleJoinRoom = () => {
    if (!email || !roomId) return;
    setMyEmail(email);
    localStorage.setItem("email", email);
    socket.emit("join-room", { emailId: email, roomId });
  };

  const handleRoomJoined = useCallback(
    ({ roomId }) => {
      navigate(`/room/${roomId}`);
    },
    [navigate]
  );

  useEffect(() => {
    socket.on("joined-room", handleRoomJoined);
    return () => {
      socket.off("joined-room", handleRoomJoined);
    };
  }, [socket, handleRoomJoined]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        
        {/* Logo */}
        <div style={styles.logoWrap}>
          <img src={logo} alt="Logo" style={styles.logo} />
        </div>

        {/* Title */}
        <h1 style={styles.title}>Join a Meeting</h1>
        <p style={styles.subtitle}>
          Enter your details to connect instantly
        </p>

        {/* Inputs */}
        <div style={styles.form}>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            placeholder="Enter your Name"
            style={styles.input}
          />

          <input
            value={roomId}
            onChange={(e) => setRoomId(e.target.value)}
            type="text"
            placeholder="Enter Room Code"
            style={styles.input}
          />

          <button onClick={handleJoinRoom} style={styles.button}>
            Enter Room
          </button>
        </div>
      </div>
    </div>
  );
};

export default Homepage;

// ---------------------------
// Premium UI Styles
// ---------------------------
const styles = {
  page: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top left, #1e293b 0%, #020617 50%, #000000 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    fontFamily:
      "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "420px",
    padding: "32px 28px 36px",
    borderRadius: "20px",
    background: "rgba(15, 23, 42, 0.75)",
    border: "1px solid rgba(148, 163, 184, 0.28)",
    backdropFilter: "blur(14px)",
    boxShadow:
      "0 30px 80px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.05)",
    textAlign: "center",
  },

  logoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "14px",
  },

  logo: {
    height: "72px",
    width: "72px",
    objectFit: "contain",
    padding: "10px",
    borderRadius: "18px",
    background: "rgba(30,41,59,0.9)",
    border: "1px solid rgba(148,163,184,0.35)",
    boxShadow: "0 8px 20px rgba(15,23,42,0.8)",
  },

  title: {
    margin: 0,
    fontSize: "28px",
    fontWeight: 600,
    color: "#f1f5f9",
  },

  subtitle: {
    marginTop: "6px",
    marginBottom: "26px",
    fontSize: "14px",
    color: "#94a3b8",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },

  input: {
    padding: "12px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid rgba(148,163,184,0.35)",
    background: "rgba(15,23,42,0.6)",
    color: "#e2e8f0",
    outline: "none",
    transition: "0.2s",
  },

  button: {
    marginTop: "10px",
    padding: "12px 0",
    borderRadius: "10px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    border: "none",
    background:
      "linear-gradient(135deg, rgba(14,165,233,0.9), rgba(34,197,94,0.9))",
    color: "#f8fafc",
    boxShadow: "0 10px 25px rgba(34,197,94,0.25)",
    transition: "transform 0.15s ease, box-shadow 0.2s ease",
  },
};

